module.exports = __webpack_public_path__ + "images/category_lp/bike/new/assessment_achievements/6@2x_a84adc01bc280b5ac2de6c37a33d0ac8.png";